import React from 'react';
import { Award, Target, TrendingUp, Layers } from 'lucide-react';
import { brandingBenefits } from '../../data/mock';

const icons = [Award, Target, TrendingUp, Layers];

const Branding = () => {
  return (
    <section id="branding" className="py-16 lg:py-20 bg-stone-800 text-stone-50 relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      
      {/* Decorative gradient */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-20">
          <p className="text-amber-400/80 text-base tracking-[0.2em] uppercase mb-4">
            {brandingBenefits.titleEn}
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-50 mb-6">
            {brandingBenefits.title}
          </h2>
          <div className="w-20 h-px bg-amber-600/40 mx-auto mb-8" />
          <p className="text-lg text-stone-300 max-w-2xl mx-auto font-light leading-relaxed">
            {brandingBenefits.subtitle}
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {brandingBenefits.benefits.map((benefit, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-stone-700/30 border border-stone-600/30 hover:bg-stone-700/50 hover:border-amber-600/30 card-hover"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-amber-600/10 flex items-center justify-center flex-shrink-0 group-hover:bg-amber-600/20 transition-colors">
                    <Icon className="w-5 h-5 text-amber-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-medium text-stone-100 mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-stone-400 font-light leading-relaxed text-base">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Brand statement */}
        <div className="mt-20 text-center">
          <blockquote className="text-3xl md:text-4xl font-light text-stone-200 max-w-3xl mx-auto leading-relaxed">
            「単なる物件管理」から<br />
            <span className="text-amber-400">「ブランド認知度の活用」</span>へ
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default Branding;
